// extracted by mini-css-extract-plugin
export default {"topNavigationBarContainer":"TopNavigationBar_topNavigationBarContainer__7vp4F","borderBottom":"TopNavigationBar_borderBottom__aOwK5","emptyBox":"TopNavigationBar_emptyBox__9HQRr"};